var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAudit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M30.0002 5H20.0002C16.3183 5 13.3335 7.98477 13.3335 11.6667V28.3333C13.3335 32.0152 16.3183 35 20.0002 35H30.0002C33.6821 35 36.6668 32.0152 36.6668 28.3333V11.6667C36.6668 7.98477 33.6821 5 30.0002 5Z",
    fill: "#0E308E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M3.3335 7.5C3.3335 6.11929 4.45278 5 5.8335 5C7.21421 5 8.3335 6.11929 8.3335 7.5V30.3333C8.3335 31.1988 8.05278 32.0409 7.5335 32.7333L5.8335 35L4.1335 32.7333C3.61421 32.0409 3.3335 31.1988 3.3335 30.3333V7.5Z",
    fill: "#0E308E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3335 11.6667H3.3335V7C3.3335 5.89543 4.22893 5 5.3335 5H6.3335C7.43807 5 8.3335 5.89543 8.3335 7V11.6667Z",
    fill: "#0E308E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.75 11.6667C18.75 10.9763 19.3096 10.4167 20 10.4167H30C30.6904 10.4167 31.25 10.9763 31.25 11.6667C31.25 12.357 30.6904 12.9167 30 12.9167H20C19.3096 12.9167 18.75 12.357 18.75 11.6667Z",
    fill: "#0E308E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.75 18.3333C18.75 17.643 19.3096 17.0833 20 17.0833H30C30.6904 17.0833 31.25 17.643 31.25 18.3333C31.25 19.0237 30.6904 19.5833 30 19.5833H20C19.3096 19.5833 18.75 19.0237 18.75 18.3333Z",
    fill: "#0E308E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.75 25C18.75 24.3096 19.3096 23.75 20 23.75H25C25.6904 23.75 26.25 24.3096 26.25 25C26.25 25.6904 25.6904 26.25 25 26.25H20C19.3096 26.25 18.75 25.6904 18.75 25Z",
    fill: "#0E308E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.4897 27.3926C38.0092 27.8472 38.0619 28.6369 37.6073 29.1565L32.8241 34.623C31.7963 35.7976 30.0259 35.9549 28.8071 34.9799L25.8857 32.6428C25.3466 32.2115 25.2592 31.4249 25.6905 30.8858C26.1217 30.3467 26.9083 30.2593 27.4474 30.6906L30.3688 33.0277C30.5429 33.167 30.7958 33.1445 30.9427 32.9767L35.7258 27.5102C36.1804 26.9907 36.9701 26.938 37.4897 27.3926Z",
    fill: "#0E308E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudit);
export default __webpack_public_path__ + "static/media/audit.92e4dda3cb26d6d43ee32e8b96470589.svg";
export { ForwardRef as ReactComponent };